<app-view-title Title="{{ 'Intellitrailer.Booking.UncofirmedBooking.TitleBookingInformation' | translate : 'Booking information' }}" [isSoftSplit]="true"></app-view-title>
<view-content [centered]="true" (scroll)="onScroll($event)">
  @if(loading) {
  <div class="loading-overlay">
    <mat-spinner diameter="70"></mat-spinner>
    <p>{{ loadingMessageKey | translate: loadingMessageText }}</p>
  </div>
  }
  @if(showVerifySpinner) {
  <div class="loading-overlay">
    <mat-progress-spinner diameter="70" mode="determinate" [value]="verifyProgressValue"></mat-progress-spinner>
    <p>{{'Itellitrailer.UnconfirmedBooking.txtVerifyingPayment' | translate: 'Verifying payment...'}}</p>
  </div>
  }
  <app-booking-summary [confirmed]="false"
                       (addableTypesChanged)="updateAddons($event)"
                       [editingExistingBooking]="this.bookingState.existingBooking"
                       [termsAccepted]="terms"
                       [booking]="bookingState.booking"
                       (bookingChange)="bookingUpdatedFromSummary($event)"
                       [atLocation]="bookingState.atLocation"
                       (changeSavedCard)="toggleSavedCard($event)"
                       (changeTerms)="toggleTerms($event)"
                       (changePrice)="updatePrice($event)"
                       [addonsFromPopup]="addonsFromPopup"
                       (sendNext)="goNext()"
                       (specialConditionChanged)="updateSpecialCondition($event)">
  </app-booking-summary>
  <div style="height: 90px"></div>
</view-content>
<view-actions mode="white">
  @if(!bookingState.existingBooking && !terms) {
  <button mat-raised-button class="wide" (click)="prepareForNext()" [disabled]="!scrolledToBottom || !terms">
    {{ 'Intellitrailer.Navigation.Scroll' | translate : 'Scroll down and confirm' }}
  </button>
  }
  @if(!this.bookingState.existingBooking && terms) {
  @if(appSettings.appType == 'web') {
  <button mat-raised-button (click)="prepareForNext()" [disabled]="!terms || !specialConditionApproved || !scrolledToBottom">
    {{ 'Intellitrailer.Navigation.Confirm' | translate : 'Confirm' }} ({{ currentPrice.DiscountedTotalPrice | currency | transliterate }})
  </button>
  }
  @else {
  @if(!(paymentFailed || paymentCancelled)) {
  <button mat-raised-button (click)="prepareForNext()" [disabled]="!terms || !specialConditionApproved">
    {{ 'Intellitrailer.Navigation.BtnPaynow' | translate : 'Pay now' }} ({{ currentPrice.DiscountedTotalPrice | currency }})
  </button>
  }
  @else {
  <button mat-raised-button (click)="retry()" [disabled]="!terms || !specialConditionApproved">
    {{ 'Intellitrailer.Booking.Payment.RetryPayment' | translate : 'Retry payment' }}
  </button>
  }
  }
  }
  @if(this.bookingState.existingBooking && !terms) {
  <button mat-raised-button (click)="prepareForNext()" [disabled]="!scrolledToBottom || !terms">
    {{ 'Intellitrailer.Navigation.Scroll' | translate : 'Scroll down and confirm' }}
  </button>
  }
  @if(this.bookingState.existingBooking && terms) {
  <button mat-raised-button (click)="prepareForNext()" [disabled]="!terms">
    {{ 'Intellitrailer.Navigation.SaveChanges' | translate : 'Save changes' }}
  </button>
  }

</view-actions>

